import Services from '../Service'

class AdminAcessoRestritoService extends Services {
  constructor() {
    super()
    this.resource = 'admin/acesso-restrito'
  }

  async getStatus() {
    return await this.getAPI(this.resource)
  }

  async unlock(senha, tela) {
    return await this.postAPI(this.resource, { senha, tela })
  }
}

export default new AdminAcessoRestritoService()
